import { Box } from "@mui/material";
import Link from "next/link";
import { actionSx } from "@/src/components/common/broadsheet/tokens";

const SignInButton = ({ url }: { url: string }) => (
  <Box component={Link} href={url ?? "#"} sx={actionSx("outline", "small")}>
    Sign in
  </Box>
);

export default SignInButton;
